import { render, staticRenderFns } from "./xianhuo.vue?vue&type=template&id=0f6a9bdc&scoped=true&"
import script from "./xianhuo.vue?vue&type=script&lang=js&"
export * from "./xianhuo.vue?vue&type=script&lang=js&"
import style0 from "./xianhuo.vue?vue&type=style&index=0&id=0f6a9bdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a9bdc",
  null
  
)

export default component.exports